module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "call-name"
  }, [_vm._v(_vm._s(_vm.title) + " "), _c('small', [_c('code', [_vm._v("/f13/" + _vm._s(_vm.callName))])])]), _vm._v(" "), _c('div', {
    staticClass: "params"
  }, [_c('div', {
    class: {
      'form-group': true, row: true, 'has-danger': !_vm.params.perf_id.length
    }
  }, [_c('label', {
    staticClass: "col-3 col-form-label",
    attrs: {
      "for": "perf-id"
    }
  }, [_vm._v("Performance ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.perf_id),
      expression: "params.perf_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "perf-id"
    },
    domProps: {
      "value": (_vm.params.perf_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.params.perf_id = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, row: true, 'has-danger': !_vm.params.price_band_code.length
    }
  }, [_c('label', {
    staticClass: "col-3 col-form-label",
    attrs: {
      "for": "price-band-code"
    }
  }, [_vm._v("Price band code")]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.price_band_code),
      expression: "params.price_band_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "price-band-code"
    },
    domProps: {
      "value": (_vm.params.price_band_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.params.price_band_code = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, row: true, 'has-danger': !_vm.params.ticket_type_code.length
    }
  }, [_c('label', {
    staticClass: "col-3 col-form-label",
    attrs: {
      "for": "ticket-type-code"
    }
  }, [_vm._v("Ticket type code")]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.ticket_type_code),
      expression: "params.ticket_type_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "ticket-type-code"
    },
    domProps: {
      "value": (_vm.params.ticket_type_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.params.ticket_type_code = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateQueryFromParams()
      }
    }
  }, [_vm._v("Go")])]), _vm._v(" "), _c('api-result', {
    attrs: {
      "results": _vm.results,
      "response": _vm.response,
      "loading": _vm.loading
    }
  }, [_c('h3', [_vm._v("Discounts")]), _vm._v(" "), _c('ul', _vm._l((_vm.results), function(discount) {
    return _c('li', {
      staticClass: "discount"
    }, [_c('p', [_vm._v(_vm._s(discount.discount_code) + " == " + _vm._s(discount.discount_desc))]), _vm._v(" "), _c('p', [_vm._v("Number available = " + _vm._s(discount.number_available))]), _vm._v(" "), _c('p', [_vm._v("Seatprice = " + _vm._s(_vm.formatPrice(discount.sale_seatprice)) + ", Surcharge = " + _vm._s(_vm.formatPrice(discount.sale_surcharge)))])])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a498cf04"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Discounts.vue
// module id = 56
// module chunks = 0